import { render } from "./CostingItem.vue?vue&type=template&id=d24690a4"
import script from "./CostingItem.vue?vue&type=script&lang=js"
export * from "./CostingItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__